export const grossMarginRequestsHeaderElements = [
  { label: "Fecha", value: "displayFecha" },
  { label: "Titular cuenta", value: "titularCuenta" },
  { label: "Cultivos", value: "displayCultivos" },
  { label: "Campaña", value: "campanaProductiva" },
  { label: "Establecimiento", value: "procedencia" },
  { label: "Estado", value: "displayEstado" },
];
